import { buildComponent } from 'src/components/factory'

import { usePendingRedirect } from 'src/hooks/use-pending-redirect'
import { useStoreState } from 'src/hooks/state'
import { useNow } from 'src/hooks/use-now'
import { useNavigationState } from '@react-navigation/native'

export const ExpiredSpaceDetection = buildComponent().withLifecycle(() => {
  const routeName = useNavigationState((state) => {
    const route = state?.routes[state?.index ?? 0]
    return route?.name ?? ''
  })
  const now = useNow()
  const loaded = useStoreState((store) => store.space.loaded)
  const expiration = useStoreState(
    (store) => store.space.expiration[store.space.id],
  )
  const expired = !!expiration && expiration < now.valueOf()

  usePendingRedirect(
    !routeName.startsWith('/account') && loaded && expired,
    '/account/expired',
    {},
    true,
  )
})
